var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82532 32.3607V30.194C1.82532 25.4075 5.70552 21.5273 10.492 21.5273H19.1587C23.9451 21.5273 27.8253 25.4075 27.8253 30.194V32.3607M27.8253 15.0273C31.4152 15.0273 34.3253 12.1172 34.3253 8.52734C34.3253 4.93749 31.4152 2.02734 27.8253 2.02734M40.8253 32.3607V30.194C40.8253 25.4075 36.9451 21.5273 32.1587 21.5273H31.0753M21.3253 8.52734C21.3253 12.1172 18.4152 15.0273 14.8253 15.0273C11.2355 15.0273 8.32532 12.1172 8.32532 8.52734C8.32532 4.93749 11.2355 2.02734 14.8253 2.02734C18.4152 2.02734 21.3253 4.93749 21.3253 8.52734Z",
    stroke: "#ED6705",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiuser);
export default __webpack_public_path__ + "static/media/multiuser.03142595a2cc56466a414eed6ed579a6.svg";
export { ForwardRef as ReactComponent };